import FetchRequest from "@/api/FetchRequest";
class builtSoundApi {
    // 基础url
    static url = "/ai/tts/history/";
    // 查询
    static getList(pageNum:number,pageSize:number): Promise<any> {
        return FetchRequest.get(this.url + 'list'+'?pageNum='+pageNum+'&pageSize='+pageSize ,true );
    }
    // 新增变语音生成
    static addSoundBuilt(roleId:number,language:string,param:any,targetFolderId:string,text:string): Promise<any> {
        const data={
            roleId:roleId,
            language:language,
            param:param,
            targetFolderId:targetFolderId,
            text:text,
        }
        return FetchRequest.post(this.url ,JSON.stringify(data) , true);
    }
    //删除
     static delSoundBuilt(ids: string): Promise<any> {
        return FetchRequest.del(this.url +ids,'' , true);
    }

}
export default builtSoundApi;